// extracted by mini-css-extract-plugin
module.exports = {"RuleWithText":"RuleWithText_RuleWithText__pYjA0"};